import ChildrenArt from "./children-art.webp";

export {ChildrenArt};